export default __webpack_public_path__ + "src/images/packages/villa-54-victoria/dcac6feba6141e6b8c012f670be424de-5.jpg";